import { render, staticRenderFns } from "./imgR.vue?vue&type=template&id=d283029a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d283029a')) {
      api.createRecord('d283029a', component.options)
    } else {
      api.reload('d283029a', component.options)
    }
    module.hot.accept("./imgR.vue?vue&type=template&id=d283029a", function () {
      api.rerender('d283029a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgR.vue"
export default component.exports